import className from "classnames"
import { useTranslation } from "react-i18next"
import { useState } from "react"
import { TimePicker as MuiTimePicker } from "@mui/x-date-pickers"

import Icon from "@/components/icon/Icon"
import { TimePickerPropsType } from "@/types/components/timePicker"
import BasicButton from "@/components/button/BasicButton"
import { HOUR_TO_SECOND_FORMAT } from "@/constants/regex"

import "./timePicker.scss"

/**
 * 값이 확정되는 순간에 이벤트를 처리하기를 원한다면 `onAccept`를 사용하십시오.
 * `onAccept`는 `onAccept`가 호출될 때까지 `value`가 변경되지 않습니다.
 * `onAccept`는 'Apply' 버튼을 클릭했을 때 호출됩니다.
 *
 * `onChange`는 값이 변경될 때마다 호출됩니다.
 * 시간, 분, 초를 선택하는순간 호출됩니다.
 */
export default function TimePicker({
  error,
  disabled,
  showMessage,
  message,
  value,
  onApply,
  onClear,
  ...props
}: TimePickerPropsType) {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className={className("TimePickerCont", className, { error, disabled })}>
      <MuiTimePicker
        {...props}
        format={HOUR_TO_SECOND_FORMAT}
        value={value}
        ampm={false}
        views={["hours", "minutes", "seconds"]}
        open={isOpen}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        slots={{
          ...props.slots,
          openPickerIcon: () => <Icon type="time" />,
          actionBar: () => (
            <div className="timepicker-action-bar">
              <BasicButton
                className="reset"
                size="sm"
                type="ghost"
                onClick={() => {
                  onClear?.()
                  setIsOpen(false)
                }}>
                {t("button.reset")}
              </BasicButton>
              <BasicButton
                className="apply"
                size="sm"
                type="primary-outlined"
                onClick={() => {
                  onApply?.(value ?? null)
                  setIsOpen(false)
                }}>
                {t("button.apply")}
              </BasicButton>
            </div>
          ),
        }}
        slotProps={{
          ...props.slotProps,
          layout: {
            ...props.slotProps?.layout,
            className: "timepicker-layout",
          },
          digitalClockSectionItem: {
            ...props.slotProps?.digitalClockSectionItem,
            className: "time-picker-item",
          },
          popper: props.slotProps?.popper,
        }}
        timeSteps={props.timeSteps || { hours: 1, minutes: 1, seconds: 1 }}
      />
      {showMessage && <p className="message">{message}</p>}
    </div>
  )
}
